export enum SubstratePermissionScope {
  'transfer' = 'transfer',
  'sign_payload_json' = 'sign_payload_json',
  'sign_payload_raw' = 'sign_payload_raw'
}
